import React from "react";
import { ButtonWithIcon } from "@components/atoms/buttons/button-with-icon/button-with-icon";
import {
  TransferButtonNewStructureObj,
  useTransferButtonNewStructureHook,
} from "./use-transfer-button-new-structure-hook";

interface TransferButtonProps {
  useHook?: () => TransferButtonNewStructureObj;
}

export const TransferButtonNewStructure = ({
  useHook = useTransferButtonNewStructureHook,
}: TransferButtonProps) => {
  const transferButtonObj = useHook();

  return (
    <>
      <ButtonWithIcon
        variant={transferButtonObj.handleButtonVariants()}
        fun={transferButtonObj.transfer}
        icon={transferButtonObj.handleTransferButtonIconColor()}
        text={transferButtonObj.transferText}
        tooltip={transferButtonObj.tooltip}
        disabled={transferButtonObj.areNoCheckboxesSelected()}
      />
    </>
  );
};
